import React, { Component } from "react";
import withAppData from "../src/HOC/withAppData";
import "../src/Styles/Pages/pmorderprocessing.scss";
import { GET } from "../src/Utils/api";
import { asset_url } from "../src/app-config";
import Loading from "../src/Loaders/Loading";
import Modal from "../src/Modal";
import { _formatCurrency, _getFromLocalStorage } from "../src/Utils/helpers";

class DriverReconUploadProof extends Component {
	constructor(props) {
		super(props);
		this.state = {
			amount: null,
			images: [],
			isLoading: true,
			previewImage: false,
			clickedImage: null,
			driverCash: 0,
			driverDeposit: 0,
			hasDeposit: false,
			hasCash: false,
			driverDetails: props.driverDetails,
			retailerDetails: props.retailerDetails,
			totalAmount: props.totalVirtualAmount,
			showSummeryDetail: false,
			moppedValue: 0,
			newWalletBalance: 0,
		};
	}

	addFile = e => {
		if (e && e.target && e.target.files) {
			let file = e.target.files[0];
			if (file && file.size > 15000000) {
				this.props.context.showAlert(
					"Image size should not be more than 15mb",
					"error",
				);
				return;
			} else {
				let fileExtension = file.name.split(".").pop().toLowerCase();
				if (
					fileExtension === "png" ||
					fileExtension === "jpeg" ||
					fileExtension === "jpg"
				) {
					let images =
						!this.state.images || this.state.images.length === 0
							? []
							: this.state.images;
					const imageObj = {
						file,
						url: window.URL.createObjectURL(file),
					};
					images.push(imageObj);
					this.setState({ images }, () => this.validate());
				} else {
					this.props.context.showAlert(
						`.${fileExtension} images are not allowed`,
						"error",
					);
					return;
				}
			}
		}
	};

	async componentDidMount() {
		await this.getData();
	}

	componentWillMount() {
		//console.log("props", this.props.driverId);
		if (this.props.driverId) {
			this.setState({ isLoading: true });
			this.getNewWalletBalance();
		}
	}

	getNewWalletBalance = async () => {
		const debit = await GET(
			`OmniPay/GetMoppedUpValueByShipmentId?shipmentId=${this.props.shipmentId}`,
		);
		const walletBalance = await GET(
			`OmniPay/GetDriverOmniPayWalletBalance?driverId=${this.props.driverId}`,
		);

		if (!debit.error) {
			this.setState({ moppedValue: debit });
		}

		if (!walletBalance.error) {
			this.setState({
				newWalletBalance: walletBalance.Data.AvailableBalance,
			});
		}
		this.setState({ isLoading: false });
	};

	getData = async () => {
		const resp = await GET(
			`PickerShipment/GetCODProof?shipmentId=${this.props.shipmentId}`,
		);
		if (resp) {
			const images =
				resp.Images && resp.Images.length > 0
					? resp.Images.map(img => ({ url: `${asset_url}${img}` }))
					: [];
			this.setState(
				{
					amount: resp.Amount || 0,
					images,
					driverCash: resp.DriverCash || 0,
					driverDeposit: resp.DriverDeposit || 0,
				},
				this.validate,
			);
		} else {
			this.setState({
				amount: 0,
				images: [],
				driverDeposit: 0,
				driverCash: 0,
			});
		}

		this.setState(
			{
				isLoading: false,
			},
			this.validate,
		);
	};

	validate = () => {
		if (this.state.hasDeposit && !this.hasImages()) {
			this.props.validateModel(false);
			return;
		}
		if (this.state.hasCash && !this.state.driverCash) {
			this.props.validateModel(false, this.state);
			return;
		}
		this.props.validateModel(true, this.state);
	};

	removeFile = index => {
		const images = this.state.images;
		const image = images[index];
		images.splice(index, 1);
		window.URL.revokeObjectURL(image.url);
		this.setState({ images }, () => this.validate());
	};

	onDriverCashChange = e => {
		if (this.isNumber(e.target.value)) {
			this.setState({ driverCash: e.target.value }, () => this.validate());
		}
	};

	onDriverDepositChange = e => {
		if (this.isNumber(e.target.value)) {
			this.setState({ driverDeposit: e.target.value }, () => this.validate());
		}
	};

	isNumber(value) {
		const re = /^[0-9\b]+$/;
		return value === "" || re.test(value);
	}

	hasImages = () => this.state.images && this.state.images.length > 0;

	showSummery = () => {
		if (this.state.showSummeryDetail === false) {
			this.setState({ showSummeryDetail: true });
		} else {
			this.setState({ showSummeryDetail: false });
		}
	};

	render() {
		const paymentProof = React.createRef();
		return this.state.isLoading ? (
			<Loading />
		) : (
			<div>
				<div className="category-container">
					<label className="category-name">1. OmniPay Account</label>
					<br />
					<div className="category-description">
						<label>
							Amount received in Driver and Retailer omnipay accounts:
						</label>
					</div>
					<div className="driver-upload-category green-bg">
						<div className="label-container field">
							<label>
								{/* {_formatCurrency(
									Number(this.props.totalVirtualAmount) +
										Number(this.props.totalDriverVaBalance) || 0,
								)} */}
								{_formatCurrency(
									Number(this.props.totalVirtualAmount) +
										Number(this.state.newWalletBalance) || 0,
								)}
							</label>
						</div>
						<div className="label-container value">
							<label></label>
							<span
								style={{
									marginLeft: "8px",
									fontFamily: "Roboto",
									fontStyle: "normal",
									fontWeight: "normal",
									fontSize: "14px",
									lineHeight: "16px",
									color: "#9699A4",
								}}
								onClick={() => this.showSummery()}
							>
								Breakdown
								<img
									style={{
										width: "12px",
										height: "7px",
										marginLeft: "4px",
										cursor: "pointer",
									}}
									src="Images/down-arrow.svg"
									alt=""
								/>
							</span>
						</div>
					</div>
					{this.state.showSummeryDetail && (
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								backgroundColor: "#edfdea",
								padding: "0px 15px",
							}}
						>
							<div>
								<p
									style={{
										fontFamily: "Roboto",
										fontStyle: "normal",
										fontWeight: "normal",
										fontSize: "14px",
										lineHeight: "16px",
										color: "#9699A4",
									}}
								>
									Retailer's OmniPay account
								</p>
								<span></span>
								{this.state.retailerDetails &&
									this.state.retailerDetails.map((item, i) => (
										<p key={i} style={{ marginBottom: "20px" }}>
											<span style={{ padding: "8px 16px" }}>{i + 1}.</span>
											<span style={{ paddingLeft: "16px" }}>
												{_formatCurrency(item || 0)}
											</span>
										</p>
									))}
							</div>

							<div>
								<p
									style={{
										fontFamily: "Roboto",
										fontStyle: "normal",
										fontWeight: "normal",
										fontSize: "14px",
										lineHeight: "16px",
										color: "#9699A4",
									}}
								>
									Driver's OmniPay account
								</p>
								<span></span>

								<div
										style={{
											display: "flex",
											flexDirection: "column",
											flexWrap: "wrap",
											justifyContent: "space-between",
											height: "50px",
										}}
									>
										<span>
											<span style={{ padding: "8px 3px" }}>{1}.</span>
											<span style={{ color: "red", fontWeight: "bold" }}>
												DR
											</span>{" "}
											{_formatCurrency(this.state.moppedValue || 0)}
										</span>
										<span>
											<span style={{ padding: "8px 3px" }}>{2}.</span>
											<span style={{ color: "green", fontWeight: "bold" }}>
												BAL
											</span>{" "}
											{_formatCurrency(this.state.newWalletBalance || 0)}
										</span>
									</div>
								
								{/* {this.props.newDriverVirtualBalance ? (
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											flexWrap: "wrap",
											justifyContent: "space-between",
											height: "50px",
										}}
									>
										<span>
											<span style={{ padding: "8px 3px" }}>{1}.</span>
											<span style={{ color: "red", fontWeight: "bold" }}>
												DR
											</span>{" "}
											{_formatCurrency(this.state.moppedValue || 0)}
										</span>
										<span>
											<span style={{ padding: "8px 3px" }}>{2}.</span>
											<span style={{ color: "green", fontWeight: "bold" }}>
												BAL
											</span>{" "}
											{_formatCurrency(this.state.newWalletBalance || 0)}
										</span>
									</div>
								) : this.state.driverDetails.length > 0 ? (
									<>
										{this.state.driverDetails.map((item, i) => (
											<p key={i} style={{ marginBottom: "20px" }}>
												<span style={{ padding: "8px 16px" }}>{i + 1}.</span>
												<span style={{ paddingLeft: "16px" }}>
													{_formatCurrency(item || 0)}
												</span>
											</p>
										))}
									</>
								) : (
									<span style={{ paddingLeft: "16px" }}>
										<span style={{ padding: "8px 16px" }}>{1}.</span>
										{_formatCurrency(this.props.driverVirtualAmount || 0)}
									</span>
								)} */}
							</div>
						</div>
					)}
				</div>

				<div className="category-container">
					<input
						id="deposits"
						type="checkbox"
						value={this.state.hasDeposit}
						onChange={() =>
							this.setState({ hasDeposit: !this.state.hasDeposit }, () =>
								this.validate(),
							)
						}
					></input>
					<label htmlFor="deposits" className="category-name">
						2. Deposits
					</label>
					<br />
					<div className="category-description">
						<label>
							Did you deposit into other channels e.g. Kudi, Sterling bank,
							Zenith bank etc.
						</label>
					</div>
					<div className="blue-bg proof-container">
						<div className="amount-container">
							<div className="amount-container-label">Amount</div>
							<div
								className={`amount-text-container ${
									!this.state.hasDeposit ? "disabled" : ""
								}`}
							>
								<label className="amount-label">{_formatCurrency(0, 2)}</label>
								<input
									type="text"
									className="amount-text"
									disabled={!this.state.hasDeposit}
									onChange={this.onDriverDepositChange}
									value={this.state.driverDeposit}
								></input>
							</div>
						</div>
						<div className="driver-upload-category">
							<div className="proof-upload-container">
								<div className="label-container">
									<label>Upload Proof of payment</label>
									&nbsp; <label className="grayed-text">e.g Bank receipt</label>
								</div>

								<div
									className="proof-image-container upload-option"
									onClick={() => paymentProof.current.click()}
								>
									<div className="img-wrapper">
										<img
											src="Images/camera.svg"
											alt=""
											className="each-imags pntr"
										/>
										<div className="info">
											To confirm your bank transfer kindly upload the proof of
											your payment e.g Bank receipt
										</div>
									</div>
									<input
										type="file"
										accept="image/*"
										className="hide"
										id={`proof-upload`}
										onChange={e => {
											this.addFile(e);
										}}
										//capture="environment"
										ref={paymentProof}
									/>
								</div>
								{this.hasImages() && (
									<div
										className="default-proof-images"
										style={{ margin: "8px 0" }}
									>
										{this.state.images.map((img, i) => {
											return (
												<div key={i} className="default-proof-images-each">
													<img
														disabled={!this.state.hasDeposit}
														onClick={() =>
															this.setState(
																{
																	previewImage: true,
																	clickedImage: i,
																},
																() => this.validate(),
															)
														}
														src={img.url}
														alt=""
														className="preview-img"
													/>
													<span
														className="remove-picture"
														onClick={() => this.removeFile(i)}
														title="Remove Picture"
													>
														×
													</span>
												</div>
											);
										})}
									</div>
								)}
								{this.hasImages() && this.state.previewImage && (
									<>
										<Modal
											header="Payment Proof"
											width="500px"
											minHeight="100px"
											isSmall={true}
											closeModal={() => this.setState({ previewImage: false })}
										>
											<div class="image-preview-modal">
												<img
													className="preview-image"
													alt=""
													src={this.state.images[this.state.clickedImage].url}
												/>
											</div>
										</Modal>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
				{this.props.driverReconcilationDetails.IsDriverLogin !== 1 && (
					<div className="category-container">
						<input
							id="cashAtHand"
							type="checkbox"
							value={this.state.hasCash}
							onChange={() =>
								this.setState({ hasCash: !this.state.hasCash }, () =>
									this.validate(),
								)
							}
						></input>
						<label htmlFor="cashAtHand" className="category-name">
							3. Cash At Hand
						</label>
						<div className="orange-bg proof-container">
							<div className="amount-container">
								<div className="amount-container-label">Amount</div>
								<div
									className={`amount-text-container ${
										!this.state.hasCash ? "disabled" : ""
									}`}
								>
									<label className="amount-label">
										{_formatCurrency(0, 2)}
									</label>
									<input
										disabled={!this.state.hasCash}
										type="text"
										className="amount-text"
										onChange={this.onDriverCashChange}
										value={this.state.driverCash}
									></input>
								</div>
							</div>
						</div>
					</div>
				)}
				{this.props.driverReconcilationDetails.PayLaterAmount !== 0 && (
					<div className="category-container uneditable">
						<input id="paylater" type="checkbox" checked disabled></input>
						<label htmlFor="payLater" className="category-name">
							{this.props.driverReconcilationDetails.IsDriverLogin !== 1
								? 4
								: 3}
							. PayLater
						</label>
						<div className="purple-bg proof-container">
							<div className="amount-container">
								<div className="amount-container-label">PayLater</div>
								<div className={`amount-text-container disabled`}>
									<label className="amount-label">
										{_getFromLocalStorage("countryData").currency}
									</label>
									<input
										disabled={true}
										type="text"
										className="amount-text"
										value={
											this.props.driverReconcilationDetails.PayLaterAmount || 0
										}
									></input>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withAppData(DriverReconUploadProof);
